import React from "react";

import Nav from "@dhn/components/atoms/nav";
import NavItem from "@dhn/components/atoms/nav-item";
import NavLink from "@dhn/components/atoms/nav-link";
import CardHeader from "@dhn/components/atoms/card-header";

export default function CardHeaderTabs({
  active,
  tabs = [],
  onClick,
  showActive,
  className = "",
  children,
}) {
  const components = tabs
    .filter((tab) => {
      if(tab?.notShow) return false;
      if (!showActive) return true;
      return active === tab.id;
    })
    .map((tab) => {
      return (
        <NavItem key={tab.id}>
          <NavLink
            active={active === tab.id}
            disabled={tab.disabled}
            onClick={() => !tab.disabled && onClick(tab.id)}
          >
            <span>{tab.name}</span>
          </NavLink>
        </NavItem>
      );
    });

  return (
    <CardHeader className={`dhn-card-header-tabs ${className}`.trim()}>
      {children || <Nav tabs>{components}</Nav>}
    </CardHeader>
  );
}
